// @ts-strict-ignore
import React, { useState } from 'react'
import queryString from 'query-string'
import { Box } from '@node-space/ui-components'
import IntegrationsTabs from '../components/IntegrationsTabs'
import { IntegrationsTabsOption, IntegrationsTabsOptions } from '../types'

export const IntegrationsLanding = () => {
  const { tab } = queryString.parse(window?.location?.search) as {
    tab?: IntegrationsTabsOption
  }
  const [activeTab, setActiveTab] = useState(tab || IntegrationsTabsOptions.API_KEYS)

  return (
    <Box width="full">
      <IntegrationsTabs queryTab={tab} activeTab={activeTab} setActiveTab={setActiveTab} />
    </Box>
  )
}
